<template>
  <div class="personal-calendar">
    <!-- personal-calendar: {{now}} -->
    <full-calendar
      ref="calendar"
      :events="user_events_and_optimizer_events_merged"
      :config="calendar_config"
      :editable="calendar_config.editable"
      :selectable="calendar_config.selectable"
      @event-selected="onEventSelect"
      @event-resize="onEventResize"
      @event-drop="onEventResize"
      @event-created="onEventCreate"
      @event-render="eventRender"></full-calendar>
    <!-- <pre>user_events_and_optimizer_events_merged: {{user_events_and_optimizer_events_merged}}</pre> -->
  </div>
</template>

<script>
import { FullCalendar } from 'vue-full-calendar'
import { mapGetters, mapActions } from "vuex";
import Color from 'color'
import moment from '@/moment-gp.js';
import $ from 'jquery';

export default {
  props: {
    now: {
      default: null
    }
  },
  name: "PersonalCalendar",
  data: () => ({
    calendar_config: {
      defaultView: 'listWeek',
      allDaySlot: false,
      editable: true,
      selectable: true,
      columnHeader: true,
      nowIndicator: true,
      header: { left: '', center: '', right: 'agendaDay,listWeek' },
      height: 500,
      themeSystem: 'bootstrap4',
      minTime: moment().format('HH:mm:ss'), // "00:00:00",
      maxTime: "24:00:00",
    },
  }),
  mounted() {
  },
  computed: {
    ...mapGetters("optimizer", [
      'masked_optimizer_results'
    ]),
    // ...mapGetters("goal", [
    //   "effort_by_effort_id",
    // ]),
    // ...mapGetters('timeslots', [
      //'flattened_calendar_data_all_one_day' // TODO
    // ]),
    ...mapGetters('calendar',[
      'calendar_all_events',
    ]),

    user_events_and_optimizer_events_merged() {
      // let mergedEvents = [ ...this.optimizer_timeline_events, ...this.user_timeline_events ];
      let mergedEvents = [ ...this.user_timeline_events ];

      /* Filer only todays events */
      mergedEvents = mergedEvents.filter(item => {
        return moment().diff( item.start, 'days' ) === 0;
      })

      // console.log("*** DAYPLAN: user_events_and_optimizer_events_merged", mergedEvents);
      return mergedEvents;
    },

    user_timeline_events() {

      // TODO: Move to store
      // TODO: Events today
      let all_events_this_week = this.calendar_all_events;

      let items = all_events_this_week.map(event => {

        let color = this.getTimeslotCollectionColor(event.tscId);

        return {
          id:     event.id,
          title:  event.cachedName,
          start:  event.userStart,
          end:    event.userEnd,
          color:  color.string(),
          data: {
            tscId:          event.tscId || null,
            goalId:         event.goalId || null,
            commitmentId:   event.commitmentId || null,
            source:         'USER',
          }
        }
      }).filter(event => event)
      return items;
    },

    /* optimizer_timeline_events() {

      // TODO: Move to store
      // TODO: Do we even need this here??

      let eventlist_calendar = this.masked_optimizer_results.map((item) => {

        let effort = this.effort_by_effort_id(item.commitmentId);
        let color = this.getTimeslotCollectionColor(effort.timeslotCollectionId)

        return {
          id:       item.pseudoId,
          title:    item.title,
          start:    moment.unix( item.start ).tz(this.user_get_timezone),
          end:      moment.unix( item.end ).tz(this.user_get_timezone),
          color:    Color(color).fade(0.33),
          data: {
            commitmentId:   item.commitmentId || null,
            tscId:          effort.timeslotCollectionId || null,
            goalId:         effort.goalId || null,
            source:         'OPTIMIZER'
          },
        };
      });
      return eventlist_calendar;
    }, */
  },
  methods: {
    ...mapActions("project", []),

    getTimeslotCollectionColor(tscId) {
      let color;
      if ( tscId ) {
        let timeslotCollection = this.$models.timeslotCollection.getNode( tscId )
        // let timeslotCollection = this.timeslot_collection_by_timeslot_collection_id(tscId);
        color = Color(timeslotCollection.color);
      } else {
        color = Color('black');
      }
      return color;
    },

    onEventSelect() {
      console.log("onEventSelect");
    },

    onEventResize() {
      console.log("onEventResize");
    },

    onEventCreate() {
      console.log("onEventCreate");
    },

    eventRender(event, rootElement) {
      if ( event.data && event.data.source === 'USER' ) {
        let element = $(rootElement.children()[2]); // HACK
        element.append( "<span class='calendar-lockbtn2'> TEST &#x1F512;</span>" );
        // element.find(".calendar-lockbtn2").click(() => {
        // });
      }
    },
  },
  components: {
    FullCalendar
  }
}
</script>

<style scoped>
</style>
